/* Rabatt-Aktion: Produktseite (Box + Aktionspreis), Marker in Menü/Kacheln,
   Bestätigung im Mini-Warenkorb, Aktionsende. Vertrauens-Zeile (dauerhaft).
   Konfiguration: snippets/aktion-head.liquid (window.RABATT_AKTION) –
   fehlt sie, ist die Aktion aus; dann läuft nur die Vertrauens-Zeile. */
(function () {
  'use strict';
  var C = window.RABATT_AKTION || null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function abgelaufen() { return !!(C && C.ende && Date.now() > C.ende); }

  /* ---------- Vertrauens-Zeile unter Menge + Warenkorb-Button ---------- */
  function vertrauenSetzen() {
    var zeile = $('[data-ra-vertrauen]');
    if (!zeile) return;
    var ziel = $('.product-details .quontiy_button') || $('.product-form .quontiy_button');
    if (!ziel) { zeile.parentNode.removeChild(zeile); return; }
    ziel.parentNode.insertBefore(zeile, ziel.nextSibling);
    zeile.hidden = false;
  }

  /* ---------- Produktseite: Box unter den Preis + Aktionspreis ---------- */
  var BETRAG = /(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})/;

  function inCent(text) {
    var m = BETRAG.exec(text || '');
    if (!m) return null;
    return parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10);
  }
  function alsText(cent) {
    var e = Math.floor(cent / 100), c = cent % 100;
    var s = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return s + ',' + (c < 10 ? '0' + c : c);
  }

  function preisAktualisieren(p, prozent) {
    var aktuell = null;
    for (var i = 0; i < p.children.length; i++) {
      var k = p.children[i];
      if (k.classList.contains('money') && !k.classList.contains('original') && !k.classList.contains('ra-pp-neu')) { aktuell = k; break; }
    }
    if (!aktuell) return;
    var alt = aktuell.textContent;
    var cent = inCent(alt);
    if (cent === null) return;
    var neuCent = Math.round(cent * (100 - prozent) / 100);
    var neuText = alt.replace(BETRAG, alsText(neuCent)).trim();

    var neu = $('.ra-pp-neu', p);
    if (!neu) {
      neu = document.createElement('span');
      neu.className = 'ra-pp-neu money';
      p.insertBefore(neu, aktuell);
    }
    if (neu.textContent !== neuText) neu.textContent = neuText;

    if (!$('.ra-pp-tag', p)) {
      var tag = document.createElement('span');
      tag.className = 'ra-pp-tag';
      tag.textContent = '−' + prozent + ' %';
      p.insertBefore(tag, aktuell.nextSibling);
    }
    p.classList.add('ra-pp');
  }

  function produktSeite() {
    var box = $('[data-ra-produktbox]');
    if (!box || !C || !C.produkt || abgelaufen()) return;
    var preis = $('.product-details p.price') || $('.product-details-wrapper p.price');
    if (!preis) { box.hidden = false; return; }

    var nach = $('.versandart-produktpage', preis.parentNode) || preis;
    nach.parentNode.insertBefore(box, nach.nextSibling);
    box.hidden = false;

    var prozent = parseInt(box.getAttribute('data-ra-prozent'), 10) || C.prozent;
    preisAktualisieren(preis, prozent);

    /* Variantenwechsel: das Theme schreibt den neuen Preis in den Preis-Bereich */
    if (window.MutationObserver) {
      var laeuft = false;
      new MutationObserver(function () {
        if (laeuft) return;
        laeuft = true;
        preisAktualisieren(preis, prozent);
        setTimeout(function () { laeuft = false; }, 0);
      }).observe(preis, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---------- Marker "−25 %" an Menüpunkten und Startseiten-Kacheln ---------- */
  function marker() {
    if (!C || !C.marker || abgelaufen()) return;
    var text = '−' + C.prozent + ' %';
    (C.kollektionen || []).forEach(function (h) {
      if (!h || h === 'alle') return;
      function links(bereich) {
        return bereich + ' a[href$="/collections/' + h + '"], ' + bereich + ' a[href*="/collections/' + h + '?"]';
      }
      $all(links('.main-header nav') + ', ' + links('.mobile-dropdown')).forEach(function (a) {
        if (a.getAttribute('data-ra-chip')) return;
        a.setAttribute('data-ra-chip', '1');
        var chip = document.createElement('span');
        chip.className = 'ra-chip';
        chip.setAttribute('aria-hidden', 'true');
        chip.textContent = text;
        (a.querySelector('.label') || a).appendChild(chip);
      });
      $all(links('.kat-boxen')).forEach(function (a) {
        var box = a.closest ? a.closest('.box') : null;
        if (!box || box.querySelector('.ra-kachel-tag')) return;
        var tag = document.createElement('span');
        tag.className = 'ra-kachel-tag';
        tag.setAttribute('aria-hidden', 'true');
        tag.textContent = text;
        box.appendChild(tag);
      });
    });
  }

  /* ---------- Bestätigung im Mini-Warenkorb ---------- */
  var wkTimer = null;
  function miniWarenkorb() {
    var notes = $all('[data-ra-cartnote]');
    if (!notes.length || !C || !C.warenkorb || !window.fetch) return;
    if (abgelaufen()) { notes.forEach(function (n) { n.hidden = true; }); return; }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var treffer = C.alle ? (cart.items || []).length > 0
          : (cart.items || []).some(function (i) { return (C.produkte || []).indexOf(i.handle) > -1; });
        notes.forEach(function (n) { n.hidden = !treffer; });
      })
      .catch(function () {});
  }
  function miniWarenkorbBald() { clearTimeout(wkTimer); wkTimer = setTimeout(miniWarenkorb, 250); }

  /* ---------- Aktionsende während die Seite offen ist ---------- */
  function endeBeobachten() {
    if (!C || !C.ende) return;
    var rest = C.ende - Date.now();
    if (rest <= 0 || rest > 2147483000) return;
    setTimeout(function () {
      document.documentElement.className += ' ra-abgelaufen';
    }, rest + 500);
  }

  function start() {
    vertrauenSetzen();
    produktSeite();
    marker();
    miniWarenkorb();
    endeBeobachten();
    if (window.MutationObserver) {
      var mini = $('[data-cart-mini-content]');
      if (mini) new MutationObserver(miniWarenkorbBald).observe(mini, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
